import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationExtractCustomFormatInsightsArgs,
  BackendStyleInsights,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractCustomFormatInsights($customerId: ID!, $customFormatId: ID!, $html: String!) {
    extractCustomFormatInsights(
      customerId: $customerId
      customFormatId: $customFormatId
      html: $html
    ) {
      fixedText
      fixedHtml
      originalText
      violations {
        text
        explanation
      }
    }
  }
`;

type Variables = BackendMutationExtractCustomFormatInsightsArgs;
type Result = BackendStyleInsights;

export const extractCustomFormatInsights = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
